<template>
  <div class="">
    <lisa-for-apps-permissions> </lisa-for-apps-permissions>
  </div>
</template>

<script>
import LisaForAppsPermissions from "@/components/profile/permissions/lisa-for-apps/index.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    LisaForAppsPermissions,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: `Modifica Permessi LisaForApp :: ${this.$route.params.user.username}`,
        path: "lisa_for_apps.index",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
    } else {
      this.notifyQueue({
        text: `Modifica Permessi LisaForApp :: ${this.$route.params.user.username}`,
        path: "lisa_for_apps.index",
        level: 3,
      });
    }
  },
};
</script>
